import { Popover, PopoverProps } from "@shopify/polaris"
import { forwardRef, useCallback, useImperativeHandle, useState } from "react"
import ReactDOM from "react-dom"
export type ProPopoverProps = Partial<PopoverProps> & {
  activator: PopoverProps["activator"]
  children: PopoverProps["children"]
  onShowChange?: (show: boolean) => void
}
export const ProPopover = forwardRef(function ProPopover(
  props: ProPopoverProps,
  ref,
) {
  const { activator, children, onShowChange, ...restprops } = props
  const [show, setShowState] = useState(false)
  const setShow = useCallback(
    (value: boolean) => {
      setShowState(value)
      onShowChange?.(value)
    },
    [onShowChange],
  )
  useImperativeHandle(ref, () => {
    return {
      setShow,
    }
  }, [setShow])
  return (
    <>
      {show &&
        ReactDOM.createPortal(
          <div
            className="fixed inset-0 z-50"
            id="popover-mask"
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              setShow(false)
            }}
          ></div>,
          document.getElementById("root")!,
        )}
      <Popover
        active={show}
        activator={
          <div
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              setShow(!show)
            }}
            className="inline-flex"
          >
            {activator}
          </div>
        }
        onClose={function () {
          setShow(false)
        }}
        {...restprops}
      >
        {children}
      </Popover>
    </>
  )
})
